import React from "react";
import { LucideIcon } from "lucide-react";

interface MetricCardProps {
  title: string;
  subtitle: string;
  value: number;
  icon: LucideIcon;
  gradientFrom: string;
  gradientTo: string;
  shadowColor?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  subtitle,
  value,
  icon: Icon,
  gradientFrom,
  gradientTo,
  shadowColor = "gray-500/25",
}) => {
  return (
    <div className="group bg-white/70 backdrop-blur-sm rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-white/20">
      <div className="p-6 sm:p-8">
        <div className="flex items-start justify-between mb-6">
          <div className="flex items-center space-x-4">
            <div
              className={`p-3 bg-gradient-to-r from-${gradientFrom} to-${gradientTo} rounded-xl shadow-lg group-hover:shadow-${shadowColor} transition-shadow duration-300`}
            >
              <Icon className="h-6 w-6 sm:h-7 sm:w-7 text-white" />
            </div>
            <div>
              <h2 className="text-sm font-medium text-gray-500 uppercase tracking-wide">
                {title}
              </h2>
              <p className="text-xs text-gray-400 mt-1">{subtitle}</p>
            </div>
          </div>
        </div>

        <div className="space-y-2">
          <div className="text-3xl sm:text-4xl font-bold text-gray-900">
            {value.toLocaleString()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
